import React  from 'react';
function TradeZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>وجوب الزكاة	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'تجب عليك الزكاة' : 'لا تجب عليك الزكاة'}</td>
        </tr>
        <tr >
          <td> إجمالي الأموال</td>
          <td>{result.moneyAmout} </td>
        </tr>
        <tr >
          <td>نصاب زكاة المال</td>
          <td>{result.threshold}  </td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من المال)</td>
          <td>{result.tradeZakat} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default TradeZakatTable;
